function shim() {};
shim.isRequired = shim;

module.exports = shim;